import { useState, type FormEvent } from 'react'
import { Link } from 'react-router'

import { api, forgetCsrfToken } from '../api.js'
import { Alert, Card, Field } from '../components/ui.js'
import { Masthead, messageFor } from './Register.js'

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    setBusy(true)
    setError(null)

    try {
      await api.signIn({
        email: String(form.get('email') ?? ''),
        password: String(form.get('password') ?? ''),
      })
      // Same as registration: the session id changed, so the token must go.
      forgetCsrfToken()
      // Tell the shell rather than navigating: the router only knows the
      // signed-out routes until the shell flips, so a navigate('/') here
      // would bounce straight back to sign-in.
      onSignedIn()
    } catch (err) {
      setError(messageFor(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="centered">
      <Card>
        <Masthead caption="Sign in to your account" />

        {error ? <Alert>{error}</Alert> : null}

        <form onSubmit={onSubmit}>
          <Field label="Email">
            <input name="email" type="email" required autoComplete="email" placeholder="you@example.com" />
          </Field>

          <Field label="Password">
            <input name="password" type="password" required autoComplete="current-password" />
          </Field>

          <div className="actions">
            <button type="submit" className="primary wide" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
        </form>

        <p className="card__note" style={{ margin: '1rem 0 0' }}>
          No account yet? <Link to="/register">Create one</Link>
        </p>
      </Card>
    </div>
  )
}
